export { default } from 'app/developer-v3/pages/contact/ContactPage';
